<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iZsDtA/tc-custom/9781616289478.jpg?1701241888307" alt="This image is the cover for the book Total Fishing Manual, Field & Stream"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Total Fishing Manual, Field & Stream
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Make your next fishing trip the best yet with this expert guide to everything the modern fisherman needs to know.</b><br/><br/> When it comes to fishing, nobody knows more than the writers and editors at <i>Field &amp; Stream</i> magazine—unless it’s the local guides, prizewinners, and other experts they interviewed for this book. <i>The Total Fishing Manual</i> is chock full of 318 field-tested tools, techniques and tactics, collected and written by the <i>Field &amp; Stream</i> editors and accompanied by amazing photos and handy illustrations. <br/><br/> GEAR UP<br/> How to pick the best lures, baits, flies, and tackle for every situation and every style of water you plan to fish. Customize your rod and reel to suit your every need. Learn how to customize your gear, get the most out of your boat, and more.<br/><br/> HIT THE WATER<br/> From small streams to major rivers, ponds to big lakes, and bays to the open ocean, hundreds of field-tested strategies will help you catch more fish with or without a boat.<br/><br/> FIND THE FISH<br/> Professional fishing guides from across the country tell you how and where to find lunker bass, trophy walleyes, huge trout, and much more right in your home waters.<br/><br/> SET THE HOOK<br/> Whether you’re bobber fishing for bluegills with the kids or heading out after the muskie of a lifetime, the techniques and tactics in this book will make your trip a success.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Cermele, The Editors of Field & Stream
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3410b228